import React, { useEffect, useState, useContext } from "react";
import H4 from "../../components/Typography/H4";
import { Outlet, Link, useNavigate, useLocation } from "react-router-dom";
import routes from "../../setup/routes";
import Button from "../../components/Button";
import Loader from "../../components/Loader";
import H5 from "../../components/Typography/H5";
import { captialCase } from "../../helper";
import { StateContext } from "../../store/context";

const UserManagement: React.FC = (): React.ReactElement => {
  const {
    authUser: { role_name },
  } = useContext(StateContext);

  const isAdmin: boolean = role_name === "admin";

  const location = useLocation();
  const accessPath = location.pathname.split("/").splice(-1)[0];
  const tabs: any = [
    { name: "Users", path: routes.USERS },
    { name: "Roles", path: routes.ROLES },
    // { name: 'Entitlements', path: routes.ENTITLEMENTS }
  ].filter((tab) => tab.name !== "Roles" || isAdmin);

  const tab = tabs.filter((t: any) => (t.path === accessPath ? t : false));

  const [selectedTab, setSelectedTab] = useState<string>(
    (tab && tab.length && tab[0].name) || "Users"
  );

  const navigate = useNavigate();

  const handleTabSelect = (e: any) => {
    const id = e.currentTarget.id;
    setSelectedTab(id);
    const selectedTab = tabs.find((a: any) => a.name === id);
    if (selectedTab && selectedTab.path) {
      navigate(selectedTab.path);
    }
  };

  return (
    <div className="flex flex-col w-full p-8 bg-white min-h-full">
      <Loader show={false} />
      <div className="flex justify-between mb-8 text-white">
        <H4>User Role Management</H4>
        {/* <Button id="newEdit" onClick={() => { }} variant="primary"> + Add New Metrics </Button> */}
      </div>
      <div className="flex border-b">
        {tabs.map((item: any) => (
          <div
            id={item.name}
            onClick={handleTabSelect}
            className={`flex rounded-t-lg py-2 px-4 mx-1 ${
              item.name === selectedTab
                ? " border-b-2 bg-primary border-black text-white"
                : ""
            } hover:bg-primary`}
          >
            <Link id={item.name} to={item.path} onClick={handleTabSelect}>
              <H5 className="text-inherit">{item.name}</H5>
            </Link>
          </div>
        ))}
      </div>
      <div className="flex">
        <Outlet />
      </div>
    </div>
  );
};

export default UserManagement;
